import BasicStatisticsDashboard from '../components/statistics/BasicStatisticsDashboard';

function StatisticsSummaryPage() {
  return <BasicStatisticsDashboard />;
}

export default StatisticsSummaryPage;
